import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Table,
} from "reactstrap";

export default function ModalGuestHistory({
  modalGuestHistoryControl,
  setModalGuestHistoryControl,
}) {
  const { guest, checkinsList } = modalGuestHistoryControl;

  function close() {
    setModalGuestHistoryControl({ ...modalGuestHistoryControl, open: false });
  }

  return (
    <Modal
      isOpen={modalGuestHistoryControl.open}
      toggle={close}
      autoFocus
      centered
    >
      <ModalHeader toggle={close}>
        {`Histórico de Check-ins${guest?.nome ? ` - ${guest.nome}` : ''}`}
      </ModalHeader>
      <ModalBody>
        {guest?.email && (
          <p style={{ marginBottom: 10 }}>{guest.email}</p>
        )}
        <div className="table-responsive">
          <Table className="table mb-0">
            <thead className="table-light">
              <tr>
                <th>Programação</th>
                <th>Data do Check-in</th>
              </tr>
            </thead>
            <tbody>
              {checkinsList.map((checkin, index) => (
                <tr key={index}>
                  <td>{checkin.tituloProgramacao}</td>
                  <td>{checkin.dataRegistro}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </ModalBody>
    </Modal>
  );
}
